// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var FormField$ReactHooksTemplate = require("../common/FormField.res.js");

function empty(param) {
  return {
          id: undefined,
          message: ""
        };
}

function setMessage(message, t) {
  return {
          id: t.id,
          message: message
        };
}

function validMessage(x) {
  return x !== "";
}

function toForm(t) {
  return {
          id: {
            TAG: "Valid",
            _0: t.id
          },
          message: t.message !== "" ? ({
                TAG: "Valid",
                _0: t.message
              }) : ({
                TAG: "Invalid",
                _0: t.message,
                _1: {
                  hd: "can't be empty",
                  tl: /* [] */0
                }
              })
        };
}

function fromForm(form) {
  return {
          id: FormField$ReactHooksTemplate.getInputValue(form.id),
          message: FormField$ReactHooksTemplate.getInputValue(form.message)
        };
}

function encoder(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "message",
                  t.message
                ],
                tl: /* [] */0
              }
            });
}

function decoder(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          message: Json_decode.field("message", Json_decode.string, json)
        };
}

var modeType = "AppLink";

exports.modeType = modeType;
exports.empty = empty;
exports.setMessage = setMessage;
exports.validMessage = validMessage;
exports.toForm = toForm;
exports.fromForm = fromForm;
exports.encoder = encoder;
exports.decoder = decoder;
/* No side effect */
